export interface ISapElement {
    feature: string;
    matNr: number;
    type: string;
    color: string;
    price: number;
    weight: number;
    delivery: number;
}

export class SapElement implements ISapElement {

    public static adapt(data: any): SapElement {
        const feature = data.FEATURE;
        const matNr = Number(data.MAT_NR);
        const type = data.TYPE;
        const color = data.COLOR;
        const price = Number(data.PRICE);
        const weight = Number(data.WEIGHT);
        const delivery = Number(data.DELIVERY);
        return new SapElement(
            feature,
            matNr,
            type,
            color,
            price,
            weight,
            delivery,
        );
    }

    constructor(
        public readonly feature: string,
        public readonly matNr: number,
        public readonly type: string,
        public readonly color: string,
        public readonly price: number,
        public readonly weight: number,
        public readonly delivery: number,
    ) { }
}
